module.exports = __webpack_public_path__ + "static/media/as4cr93.0c2da4ef.png";